export default __webpack_public_path__ + "static/media/feedback-icon.57711734.svg";